import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import theme from '../styles/theme';

import { postAPI, userAPI } from '../service/api';
import { useUserContext } from '../contexts/UserContext/index';

import { Header, Spinner, Text } from '../components/atoms';
import { QuestionItem } from '../components/organisms';
import storageUtil from '../utils/localStorage';

const channelId = '6182c2ce41316567ffd9bcaa';

const LikePosts = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;

const LikesPage = () => {
  const { handleGetUser } = useUserContext();

  const [isLoading, setIsLoading] = useState(false);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      const user = await userAPI.getUser(storageUtil.getItem('TOKEN', ''));

      const posts = await Promise.all(
        (user.likes || []).map(async ({ post: postId }) => {
          const post = await postAPI.getPost(postId);
          // TODO: format 함수 util화해주기
          return { id: post._id, ...post };
        }),
      );

      setPosts(posts.filter(({ channel: { _id } }) => channelId === _id));
      setIsLoading(false);
    };

    fetchPosts();
  }, [handleGetUser]);

  return (
    <>
      <Header style={{ marginBottom: theme.spacing.xl }}>좋아요한 질문</Header>
      {isLoading ? (
        <Spinner />
      ) : (
        <LikePosts>
          {posts?.map((post) => (
            <QuestionItem key={post.id} post={post} />
          ))}
        </LikePosts>
      )}
      {!isLoading && posts.length === 0 ? (
        <Text>좋아요한 질문이 없습니다😥</Text>
      ) : null}
    </>
  );
};

export default LikesPage;
